<template lang="pug">
  .form__item.form__item_dropdown(
    v-tap="toggleList"
    v-tap-outside="hideList"
    :class="{ 'form__item_invalid': !!error }"
  )
    .form__item-error {{ error }}
    label
      input(
        type="hidden"
        v-bind="$attrs"
        :value="fieldValue"
      )
      input.form__item-input.form__item-input_dropdown(
        readonly
        :value="displayedName"
        :class="{ 'form__item-input_active': !!value }"
      )
      .form__item-arrow(:class="{'form__item-arrow_active': active}")
      span.form__item-label {{ label }}
    .form__item-list(v-if="active")
      .form__item-list__item(
        v-for="el in options"
        :key="el.id"
        v-tap="() => selectItem(el)"
      )
        | {{ el.name }}
</template>

<script>
export default {
  name: 'BaseDropdown',
  props: {
    label: String,
    value: Object,
    error: String,
    options: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    active: false
  }),
  computed: {
    displayedName: (vm) => vm?.value?.name || '',
    fieldValue: (vm) => vm?.value?.id || ''
  },
  methods: {
    toggleList () {
      this.active = !this.active
    },
    hideList () {
      this.active = false
    },
    selectItem (value) {
      this.$emit('input', value)
    }
  }
}
</script>
